
import { Watch, Mixins, Component, Vue, Ref, Provide, ProvideReactive } from "vue-property-decorator";
import TablePagination from "@/mixins/tablePagination";
import Resize from "@/mixins/resize";

import TongueExplain from "./components/explain.vue";
import TongueSymptom from "./components/symptom.vue";
import TongueCorporeity from "./components/corporeity.vue";
import Eight from "./components/eight.vue";
import TongueSubSymptom from "./components/subSymptom.vue";

@Component({
    inject: [],
    components: {
        TongueExplain,
        TongueSymptom,
        TongueCorporeity,
        Eight,
        TongueSubSymptom
    }
  })
export default class Tongue extends Mixins(Resize, TablePagination) {
    currentTab = "0";
    tabList = [{ name: "0", id: 0, label: "症状" }, { name: "1", id: 1, label: "九种体质" }, { name: "2", id: 2, label: "八纲辨证" }, { name: "3", id: 3, label: "舌诊名词解释" }, { name: "4", id: 4, label: "副症状配置" }];
}
